import { z } from 'zod';

export const schemaConsorsIban = z
    .string()
    .min(5)
    .max(34)
    .regex(/^[a-zA-Z]{2}[0-9a-zA-Z]+$/, 'Invalid characters');
